import { styled } from '@mui/system'
import Typography from '../../../atoms/typography'

const Root = styled('div')`
	display: flex;
	flex-direction: column;
	padding: 0 24px;
	margin: auto;
	max-width: 732px;
	${({ theme }) => theme.breakpoints.up('md')} {
		padding: 0 77px;
	}
	${({ theme }) => theme.breakpoints.up('lg')} {
		padding: 0 146px;
	}
`
const NotRegistered = styled('div')`
	display: flex;
	flex-direction: column;
	padding: 48px;
	background-color: ${({ theme }) => theme.palette.grey.lighter};
	align-items: center;
	margin-bottom: 80px;
`
const GuestOrderLink = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 112px;
	padding: 0 48px;
`

const Title = styled(Typography)`
	margin-bottom: 34px;
	text-align: center;
`
const Subtitle = styled(Typography)`
	margin-bottom: 32px;
	text-align: center;
	color: ${({ theme }) => theme.palette.grey.main};
`

export { Root, NotRegistered, GuestOrderLink, Title, Subtitle }
